import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface Package{
  id: number,
  name: string,
  day: number,
  exams: number,
  dollar_price: number,
  dollar_sale_price?: number,
  rial_price: number,
  rial_sale_price?: number,
  note?: string,
  pros?: string,
  cons?: string,
  is_premium: boolean,
  popular: boolean,
  status: string
}

export interface Payment{
  tracking_code?:string,
  package_id:number
}

export interface Discount{
  code?:string,
  package_id:number
}

export interface DiscountRes{
  qualify: boolean,
  message: string ,
  off_fix_rial: number,
  off_fix_dolar: number,
  off_percent: number,
  id?: number
}

export interface PayRes {
  url: string,
  message?: string
  status: boolean
}

export const packageApi = createApi({
  reducerPath: 'packageApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['package','payment','discount'],

  endpoints: (builder) => ({
    getPackages: builder.query<Package[],void>({
      query: () => 'package/all',
      providesTags: ['package']
    }),
    getPack: builder.query<Package,number>({
      query: (id) => `package/${id}`,
      providesTags: ['package']
    }),

    packageDollarPay: builder.mutation<PayRes, Payment>({
      query: (data) => ({
        url: '/payment/dollar-pay',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['payment']
    }),
    packageRialPay: builder.mutation<PayRes, Payment>({
      query: (data) => ({
        url: '/payment/rial-pay',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['payment']
    }),
    checkDiscount: builder.mutation<DiscountRes, Discount>({
      query: (data) => ({
        url: '/dicount-code/check',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['discount']
    }),
  }),
})

export const { useGetPackagesQuery, useGetPackQuery, usePackageDollarPayMutation ,
  usePackageRialPayMutation, useCheckDiscountMutation } = packageApi
